'use strict';

module.exports = [
	function () {

		return {
			restrict: 'A',
			scope: {
				active: '=cbIsActive'
			},
			link: function (scope, element, attributes) {
				let icon = element.find('.md-container .md-icon');
				let color = attributes.cbChangeColor;

				scope.$watch('active', (newValue) => {
					if(newValue == true) {
						icon.css('background-color', color);
					} else {
						icon.css('background-color', 'unset');
					}
				});
			}
		};
	}
];

